import React from "react";

/**
 * Placeholder card-back plate for cards whose reference image isn't cached
 * yet.  The PRD rule is: never a broken image, never hotlink TCGdex.
 *
 * Renders a subtle diagonal weave on the page-background colour with a
 * small CardCapture mark.  Uses the 5:7 aspect ratio the design system
 * mandates for card imagery.
 */
export default function CardPlaceholder({ label, className = "" }) {
  return (
    <div
      className={`cc-card-plate w-full ${className}`}
      style={{ aspectRatio: "5 / 7" }}
      aria-hidden={!label}
      role={label ? undefined : "presentation"}
      data-testid="card-placeholder"
    >
      <svg width="34" height="34" viewBox="0 0 24 24" fill="none"
           className="opacity-40">
        <circle cx="12" cy="12" r="9" stroke="#4C5261" strokeWidth="1.4" />
        <circle cx="12" cy="12" r="3" fill="#4C5261" />
        <path d="M12 3v6M12 15v6M3 12h6M15 12h6"
              stroke="#4C5261" strokeWidth="1.4" strokeLinecap="round" />
      </svg>
      {label && (
        <span className="sr-only">{label}</span>
      )}
    </div>
  );
}
